import {PlatformDTO} from "./platformDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface SiteDTO extends BaseIntDTO {
  siteName?: string;
  platformId?: number;
  platform?: PlatformDTO;
}
